"use strict";
// Before using this component in your app, remember to embed the stylesheet for Leaflet in your main html file.
// See the readme file for more details.
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_leaflet_1 = require("react-leaflet");
var styled_components_1 = __importDefault(require("styled-components"));
var bing_layer_component_1 = __importDefault(require("./bing-layer.component"));
var map_zoom_controls_component_1 = __importDefault(require("./zoom-controls/map-zoom-controls.component"));
var clustered_map_installations_component_1 = __importDefault(require("./clustered-map-installations.component"));
var map_point_of_interest_component_1 = __importDefault(require("./map-point-of-interest.component"));
var map_bounds_handler_component_1 = __importDefault(require("./map-bounds-handler.component"));
exports.MapContext = react_1.default.createContext({
    zoomFactor: 12,
});
var MapContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: ", ";\n  flex-grow: 1;\n\n  .leaflet-control-attribution {\n    display: none !important;\n  }\n\n  .leaflet-container {\n    position: relative;\n    flex-grow: 1;\n    width: 100%;\n    z-index: 99;\n    background: ", ";\n\n    .leaflet-div-icon {\n      background: transparent;\n      border: 0;\n    }\n\n    .map-wait-info {\n      position: absolute;\n      z-index: 500;\n      text-align: center;\n      width: 100%;\n      padding-top: 150px;\n\n      span {\n        padding: 0.75em 1em;\n        background-color: white;\n        border-radius: 0.25em;\n      }\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: ", ";\n  flex-grow: 1;\n\n  .leaflet-control-attribution {\n    display: none !important;\n  }\n\n  .leaflet-container {\n    position: relative;\n    flex-grow: 1;\n    width: 100%;\n    z-index: 99;\n    background: ", ";\n\n    .leaflet-div-icon {\n      background: transparent;\n      border: 0;\n    }\n\n    .map-wait-info {\n      position: absolute;\n      z-index: 500;\n      text-align: center;\n      width: 100%;\n      padding-top: 150px;\n\n      span {\n        padding: 0.75em 1em;\n        background-color: white;\n        border-radius: 0.25em;\n      }\n    }\n  }\n"])), function (_a) {
    var height = _a.height;
    return (height ? height : '100vh');
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.map.terrain;
});
MapContainer.displayName = 'MapContainer';
var defaultBounds = [
    [56.381668, 9.68151],
    [56.37678, 9.664984],
];
var Map = function (props) {
    var installations = props.installations, pointsOfInterest = props.pointsOfInterest, height = props.height, children = props.children, center = props.center, showDetails = props.showDetails, _a = props.showZoomControls, showZoomControls = _a === void 0 ? true : _a;
    var _b = react_1.useState(18), zoomFactor = _b[0], setZoomFactor = _b[1];
    var _c = react_1.useState(defaultBounds), bounds = _c[0], setBounds = _c[1];
    var boundsAreSet = react_1.useRef(false);
    react_1.useEffect(function () {
        if ((installations || pointsOfInterest) && !boundsAreSet.current) {
            boundsAreSet.current = true;
            setBounds(__spreadArrays((pointsOfInterest || []), (installations || [])).map(function (_a) {
                var _b = _a.location, latitude = _b.latitude, longitude = _b.longitude;
                return [
                    latitude,
                    longitude,
                ];
            }));
        }
    }, [installations, pointsOfInterest]);
    var mapContext = react_1.useMemo(function () {
        return {
            zoomFactor: zoomFactor,
        };
    }, [zoomFactor]);
    var zoomHandler = function (event) {
        var _zoom = event.target._zoom;
        setZoomFactor(_zoom);
    };
    return (react_1.default.createElement(MapContainer, { "data-test-id": "map_page", height: height },
        react_1.default.createElement(react_leaflet_1.Map, { zoomAnimation: true, fadeAnimation: true, markerZoomAnimation: true, onZoomlevelschange: zoomHandler, onZoomend: zoomHandler, zoomControl: false },
            react_1.default.createElement(map_bounds_handler_component_1.default, { bounds: bounds, center: center },
                react_1.default.createElement(exports.MapContext.Provider, { value: mapContext },
                    react_1.default.createElement(bing_layer_component_1.default, null),
                    showZoomControls && react_1.default.createElement(map_zoom_controls_component_1.default, null),
                    react_1.default.createElement(clustered_map_installations_component_1.default, { installations: installations || [], setBounds: setBounds, showDetails: showDetails }), pointsOfInterest === null || pointsOfInterest === void 0 ? void 0 :
                    pointsOfInterest.map(function (point) { return (react_1.default.createElement(map_point_of_interest_component_1.default, { location: point.location, key: point.id })); }),
                    children)))));
};
Map.displayName = 'Map';
exports.default = Map;
var templateObject_1;
